export const intercomHelpCenterId = '9207167'
export const intercomAccountBlockedId = '9207905'
